/* eslint-disable implicit-arrow-linebreak */
export const countAdults = (rooms) =>
    rooms.reduce((total, value) => total + value.adults.length, 0);

export const countChildren = (rooms) =>
    rooms.reduce((total, value) => total + value.children.length, 0);
